import { useRef, useState } from 'react';
import { AText, Box, useOnClickOutside } from '@alf/uikit';
import { useConfig } from '@namespace/cms';
import { useI18n } from '@namespace/i18n';
import { Icon } from '@namespace/icons2';
import SettingsComponentsList from '../../common/SettingsComponentsList';

import styles from './index.module.css';

const Settings = ({ id }) => {
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const containerRef = useRef(null);
  const iconRef = useRef(null);
  const { t } = useI18n();
  const { config = {} } = useConfig(id);
  const { customRightMargin = false } = config;

  const hidePopup = () => setIsSettingsOpen(false);

  useOnClickOutside(hidePopup, containerRef, iconRef);

  return (
    <>
      <Box margin="0 s" className={styles.settingIcon} ref={iconRef}>
        <Icon
          onClick={() => setIsSettingsOpen(!isSettingsOpen)}
          name="icons/general/state/settings"
          size="m"
          color="btn_quaternary_color_4"
        />
      </Box>
      {isSettingsOpen && (
        <Box
          style={customRightMargin && { right: customRightMargin }}
          className={styles.settingPopup}
          ref={containerRef}
          padding="s"
          direction="column"
        >
          <Box
            className={styles.popupHeader}
            align="center"
            justify="between"
            margin="0 0 s 0"
          >
            <AText breed="BU" size="m" color="po_header_txt_color_1">
              {t('header.settings')}
            </AText>
            <Box onClick={() => setIsSettingsOpen(false)}>
              <Icon
                name="icons/general/action/close"
                size="xs"
                color="state_info"
                className={styles.closeIcon}
              />
            </Box>
          </Box>
          <Box className={styles.popupBody}>
            <SettingsComponentsList
              config={config}
              schemeSwitcherIconSize="s"
            />
          </Box>
        </Box>
      )}
    </>
  );
};

export default Settings;
